<app-data-grid
  [mode]="locked ? 'view' : 'edit'"
  [state]="state"
  [fontSize]="fontSize"
  (valueChange)="cacheChanges()"
  [columns]="columns"
  [dataItems]="changeset"
  [filterable]="'menu'"
  (dataStateChange)="fetchChangesets($event)"
  (filterChange)="filterChanged($event)"
>
  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="comboName"
  >
    <app-custom-filter
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="entreeParId"
  >
    <app-custom-filter
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="entreeName"
  >
    <app-custom-filter
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    columnTemplate
    field="entreeName"
    let-row="row"
    let-column="column"
  >
    <span class="k-d-flex k-gap-md k-align-items-center">
      <app-column [data]="row" [column]="column" [fontSize]="fontSize">
      </app-column>
      <button
        *ngIf="row.status == 'Pending Pricing'"
        kendoButton
        [title]="'This item is pending sync to PAR'"
        class="m-l-4 info-bg badge-button"
        size="small"
        rounded="full"
      >
        Pending
      </button>

      <button
        *ngIf="row.hasDirty()"
        kendoButton
        [title]="'This item has unsaved changes'"
        class="m-l-4 warning-bg badge-button"
        size="small"
        rounded="full"
      >
        Unsaved
      </button>

      <button
        *ngIf="row.status == 'Scheduled Pricing'"
        kendoButton
        [title]="'This item is scheduled to sync with PAR'"
        class="m-l-4 success-bg badge-button"
        size="small"
        rounded="full"
      >
        Scheduled
      </button>
    </span>
  </ng-template>

  <ng-template
    columnTemplate
    let-column="column"
    let-row="row"
    field="newPrice"
  >
    <span class="k-d-flex k-justify-content-center">
      <kendo-numerictextbox
        disableMouseWheel
        *ngIf="
          !(row.entreeOverridden || row.isTwoItemCombo) && !row.locked;
          else plainColumn
        "
        [style.fontSize.rem]="fontSize"
        [spinners]="false"
        (valueChange)="onValueChange(row, column.field)"
        [ngClass]="{
          warning: row.warnings?.has(column?.field),
          error: row.errors?.has(column.field),
        }"
        [step]="0.1"
        [(ngModel)]="row.newPrice"
      >
        <ng-template kendoSuffixTemplate>
          <span
            *ngIf="row.dirty?.has(column.field) && row.dirty.get(column.field)"
            kendoTooltip
          >
            <fa-icon
              class="m-r-2"
              [title]="'You have unsaved changes'"
              [icon]="['fas', 'pen']"
            >
            </fa-icon>
          </span>
        </ng-template>
      </kendo-numerictextbox>

      <ng-template #plainColumn>
        <app-column
          [fontSize]="fontSize"
          [data]="row"
          [column]="column"
        ></app-column>
      </ng-template>

      <fa-icon
        *ngIf="row.entreeOverridden || row.isTwoItemCombo"
        [icon]="['fas', 'exclamation-triangle']"
        class="text-warning"
        kendoTooltip
        title="Entree needs to be overridden for this specific combo, please manage its pricing following the Custom link."
      ></fa-icon>
      <button
        *ngIf="row.entreeOverridden || row.isTwoItemCombo"
        kendoButton
        size="small"
        (click)="currentComponentId = row.entreeId"
        fillMode="link"
        themeColor="primary"
      >
        <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
        Custom
      </button>
    </span>
  </ng-template>

  <ng-template
    columnTemplate
    field="deliveryPrice"
    let-row="row"
    let-column="column"
  >
    <p
      *ngIf="row.deliveryPrice == null"
      [style.textAlign]="column.align || 'center'"
      [style.fontSize.rem]="fontSize"
      class="m-0 italic-text"
      kendoTooltip
      title="In-store price applied by default"
    >
      {{ row.itemPrice | currency: "USD" }}
    </p>
    <app-column
      [fontSize]="fontSize"
      [data]="row"
      [column]="column"
      *ngIf="row.deliveryPrice != null"
    >
    </app-column>
  </ng-template>

  <ng-template headerTemplate field="comboDiscount" let-column="column">
    <div class="k-column-title" kendoPopoverContainer>
      {{ column.title }}
      <app-combo-markup-info></app-combo-markup-info>
    </div>
  </ng-template>

  <ng-template headerTemplate field="toyPrice" let-column="column">
    <div class="k-column-title" kendoPopoverContainer>
      {{ column.title }}
      <fa-icon
        kendoPopoverAnchor
        [popover]="toyPricePopover"
        [showOn]="'hover'"
        class="info"
        [icon]="['fas', 'circle-info']"
      ></fa-icon>
    </div>
    <kendo-popover #toyPricePopover>
      <ng-template kendoPopoverBodyTemplate>
        You can set the price for the Kids Meal toy in the Substitutions screen,
        located in the menu above.
      </ng-template>
    </kendo-popover>
  </ng-template>

  <ng-template headerTemplate field="comboMarkup" let-column="column">
    <div class="k-column-title" kendoPopoverContainer>
      {{ column.title }}
      <app-combo-discount-info></app-combo-discount-info>
    </div>
  </ng-template>

  <ng-template     
    columnTemplate
    field="newDeliveryPrice"
    let-row="row"
    let-column="column">
      <app-editable-column
        *ngIf="!locked"
        kendoTooltip
        [title]="row.isDeliveryAvailable == false ? 'This item is not available for delivery pricing.' : 'Entree needs to be overridden for this specific combo, please manage its pricing following the Custom link.'"
       [fontSize]="fontSize"
       [dataItem]="row"
       [column]="column"
       (valueChange)="onValueChange($event.dataItem, $event.field)"
       [disabled]="row.isDeliveryAvailable == false || row.entreeOverridden || row.isTwoItemCombo"
      [placeholder]="row.isDeliveryAvailable == false ? 'N/A' : ''"
     ></app-editable-column>

          <app-column
      *ngIf="locked"
       [fontSize]="fontSize"
       [data]="row"
       [column]="column"
       ></app-column>
  </ng-template>
</app-data-grid>

<kendo-dialog
  *ngIf="currentComponentId != null && restaurantId != null"
  (close)="currentComponentId = null"
  title="Override Prices"
>
  <app-override-grid
    [locked]="locked"
    [onlyEntrees]="true"
    [componentId]="currentComponentId"
    [restaurantId]="restaurantId"
    [productType]="productTypeId"
    (valueChange)="fetchChangesets(state)"
  ></app-override-grid>
</kendo-dialog>
